import { growthbookIntegration as growthbookIntegration$1 } from '@sentry/core/browser';

const growthbookIntegration = (({ growthbookClass }) => growthbookIntegration$1({ growthbookClass }));

export { growthbookIntegration };
//# sourceMappingURL=integration.js.map
